import HomePage from "./pages/HomePage";
import CatalogPage from "./pages/CatalogPage";
import ProductDetailPage from "./pages/ProductDetailPage";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import StorefrontLayout from "./components/StorefrontLayout";

/** @type {import('../types').StorefrontTenantModule} */
const mx = {
  key: "mx",
  label: "VBS Mexico",
  domains: ["vbspecialties.com.mx", "www.vbspecialties.com.mx"],
  codePath: "public-web/src/storefronts/mx",
  pages: {
    home: HomePage,
    catalog: CatalogPage,
    productDetail: ProductDetailPage,
    cart: CartPage,
    checkout: CheckoutPage,
    layout: StorefrontLayout,
  },
};

export default mx;
